/**
 * @file useEditParam.ts
 * @description Открытая на правку запись справочника — в адресе `?edit=<id>`
 * (phase19.31, каркас справочника (б) разбора B).
 *
 * Зачем в адресе: строка справочника целиком — ссылка (`rowHref`), как в
 * реестрах; правка открывается окном поверх списка, «назад» в браузере его
 * закрывает, ссылкой на запись можно поделиться. `?edit=new` — новая запись.
 */

import { useCallback } from "react";
import { useSearchParams } from "react-router";

const KEY = "edit";
export const NEW_RECORD = "new";

export function useEditParam() {
  const [params, setParams] = useSearchParams();
  const editId = params.get(KEY);

  const open = useCallback(
    (id: string) =>
      setParams((prev) => {
        const next = new URLSearchParams(prev);
        next.set(KEY, id);
        return next;
      }),
    [setParams],
  );

  const close = useCallback(
    () =>
      setParams(
        (prev) => {
          const next = new URLSearchParams(prev);
          next.delete(KEY);
          return next;
        },
        { replace: true },
      ),
    [setParams],
  );

  /** Адрес строки: тот же раздел с `?edit=<id>`. */
  const hrefFor = useCallback((id: string) => `?${KEY}=${encodeURIComponent(id)}`, []);

  return { editId, isNew: editId === NEW_RECORD, open, close, hrefFor };
}
